import {CellContent, TableConfig, TCTypeEnum, FilterRoleEnum} from 'ngx-satoris';
import {UserPlatformRole} from 'src/app/shared/models/user';
import {environment} from 'src/environments/environment';

export enum TableUsersEnum {
  ID = 'id',
  USER_ID = 'userId',
  NAME = 'name',
  ROLE = 'role',
  EMAIL = 'email',
  CREATION_DATE = 'creationDate'
}

export enum TableUsersFilterEnum {
  USER_ID = 'userId',
  NAME = 'name',
  ROLE = 'role',
  EMAIL = 'email',
  CREATE_AT_START = 'createAtStart',
  CREATE_AT_END = 'createAtEnd'
}

export const TABLE_USERS_CONFIG: TableConfig = {
  tableId: 'table-users-evisa',
  version: '1.0.1',
  rowsClickable: true,
  useFilterCheckbox: true,
  pagination: {
    serverPagination: true,
    itemsPerPage: [5, 10, 15, 20, 30, 50],
    activeItemsPerPage: 20,
    enablePageDataCaching: true,
    preloadPages: 1
  },
  rowsExpandable: {
    active: false
  },
  menusDisplay: {
    isFilterPanelCollapsed: false,
    isColumnPanelCollapsed: true
  },
  table: {
    [TableUsersEnum.ID]: {
      visible: true,
      value: 'id',
      sortable: true,
      serverSorting: true,
      filterable: true,
      truncateMaxLength: 30,
      data: [] as CellContent[],
      filter: [{
        type: TCTypeEnum.NUMBER,
        role: FilterRoleEnum.SINGLE,
        rowIndex: 1,
        serverFilter: true,
        filterId: TableUsersFilterEnum.USER_ID,
        validators: {
          maxLength: 50
        }
      }]
    },
    [TableUsersEnum.USER_ID]: {
      visible: false,
      value: 'userId',
      sortable: true,
      serverSorting: false,
      filterable: false,
      truncateMaxLength: 30,
      data: [] as CellContent[]
    },
    [TableUsersEnum.NAME]: {
      visible: true,
      value: 'name',
      sortable: true,
      serverSorting: true,
      filterable: true,
      data: [] as CellContent[],
      filter: [{
        type: TCTypeEnum.TEXT,
        role: FilterRoleEnum.SINGLE,
        rowIndex: 2,
        serverFilter: true,
        filterId: TableUsersFilterEnum.NAME,
        validators: {
          minLength: 2,
          maxLength: 50
        }
      }]
    },
    [TableUsersEnum.ROLE]: {
      visible: true,
      value: 'role',
      sortable: true,
      serverSorting: true,
      filterable: true,
      data: [] as CellContent[],
      filter: [{
        type: TCTypeEnum.SELECT,
        role: FilterRoleEnum.SINGLE,
        serverFilter: true,
        filterId: TableUsersFilterEnum.ROLE,
        selectOptions: Object.keys(UserPlatformRole)
          .filter(key => isNaN(Number(key)))
          .filter(role => !environment.hideNoctisConsumerUsersInUsersTable || UserPlatformRole[role as keyof typeof UserPlatformRole] !== UserPlatformRole.ORBIS_CONSUMER)
          .map(role => ({
            value: UserPlatformRole[role as keyof typeof UserPlatformRole],
            name: `DYN.role.${UserPlatformRole[role as keyof typeof UserPlatformRole]}`
          }))
      }]
    },
    [TableUsersEnum.EMAIL]: {
      visible: true,
      value: 'accountName',
      sortable: true,
      serverSorting: true,
      filterable: true,
      data: [] as CellContent[],
      filter: [{
        type: TCTypeEnum.EMAIL,
        role: FilterRoleEnum.SINGLE,
        serverFilter: true,
        filterId: TableUsersFilterEnum.EMAIL,
        validators: {
          email: true,
          minLength: 4,
          maxLength: 50
        }
      }]
    },
    [TableUsersEnum.CREATION_DATE]: {
      visible: true,
      value: 'confirmedAt',
      sortable: true,
      serverSorting: true,
      filterable: true,
      data: [] as CellContent[],
      filter: [
        {
          type: TCTypeEnum.DATE,
          role: FilterRoleEnum.DATE_FROM,
          rowIndex: 3,
          serverFilter: true,
          filterId: TableUsersFilterEnum.CREATE_AT_START,
          validators: {
            maxDate: new Date()
          }
        },
        {
          type: TCTypeEnum.DATE,
          role: FilterRoleEnum.DATE_TO,
          rowIndex: 4,
          serverFilter: true,
          filterId: TableUsersFilterEnum.CREATE_AT_END,
          validators: {
            maxDate: new Date()
          }
        }
      ],
      dateFormat: 'dd/MM/yyyy HH:mm'
    }
  }
};

export const ORIGINAL_TABLE_USERS_CONFIG: TableConfig = JSON.parse(JSON.stringify(TABLE_USERS_CONFIG));
